import "../styles/LocationSerene.css";
import LocationMapVideo from "../assets/serene-images/serene-location-image.mp4";
import { motion } from "framer-motion";

export default function LocationSerene() {
  // ✅ Card & children stagger animation
  const cardStagger = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.15,
      },
    },
  };

  // ✅ Bottom to top fade animation
  const fadeUp = {
    hidden: { opacity: 0, y: 40, filter: "blur(8px)" },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: 0.9, ease: "easeOut" },
    },
  };

  // ✅ Video animation (fade)
  const videoVariant = {
    hidden: { opacity: 0, scale: 0.98, filter: "blur(10px)" },
    show: {
      opacity: 1,
      scale: 1,
      filter: "blur(0px)",
      transition: { duration: 1.1, ease: "easeOut" },
    },
  };

  // ✅ Word by word animation (same as your H1)
  const wordContainer = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.15,
      },
    },
  };

  const wordVariant = {
    hidden: { y: 35, opacity: 0, filter: "blur(6px)" },
    show: {
      y: 0,
      opacity: 1,
      filter: "blur(0px)",
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  // ✅ split title words
  const sageTitle = "Prime Location".split(" ");


  return (
    <section id="serene-location" className="location-serene position-relative">
      <div className="location-serene-media" aria-hidden="true">
        {/* Gradient overlay for readability */}
        <div className="location-serene-overlay" />
      </div>

      {/* ✅ Content Card animation */}
      <motion.div
        className="location-serene-icon col-lg-4 rounded-4"
        variants={cardStagger}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.5 }}
      >
        {/* ✅ Video animation */}
        <motion.video
          className="location-video mb-4"
          src={LocationMapVideo}
          autoPlay
          muted
          loop
          playsInline
          variants={videoVariant}
        />

        {/* ✅ Title */}
        {/* ✅ H1 word by word */}
        <motion.h1 className="sage-title display-4" variants={wordContainer}>
          {sageTitle.map((word, i) => (
            <motion.span
              key={`sage-${i}`}
              variants={wordVariant}
              style={{ display: "inline-block", marginRight: "0.35em" }}
            >
              {word}
            </motion.span>
          ))}
        </motion.h1>

        {/* ✅ Text */}
        <motion.p className="location-text" variants={fadeUp}>
          Vessella Serene is located in a peaceful green zone, offering quick
          access to Tbilisi city centre while maintaining privacy and clean air.
        </motion.p>

        {/* ✅ Button */}
        <motion.a
          href="https://maps.app.goo.gl/zJXisRjhHWQAL7s68"
          target="_blank"
          rel="noopener noreferrer"
          className="location-btn d-inline-flex align-items-center text-decoration-none"
          variants={fadeUp}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
        >
          View on map
          <i className="fa-solid fa-arrow-right ms-2"></i>
        </motion.a>

      </motion.div>
    </section>
  );
}
